export const DOCUMENT_MUTATOR_LOAD_SELECTED = 'DOCUMENT_MUTATOR_LOAD_SELECTED'
export const DOCUMENT_MUTATOR_RESET_DEFAULTS = 'DOCUMENT_MUTATOR_RESET_DEFAULTS'
export const DOCUMENT_MUTATOR_SET_BUILDING_ID = 'DOCUMENT_MUTATOR_SET_BUILDING_ID'
export const DOCUMENT_MUTATOR_SET_CLIENT_ID = 'DOCUMENT_MUTATOR_SET_CLIENT_ID'
export const DOCUMENT_MUTATOR_SET_FILE = 'DOCUMENT_MUTATOR_SET_FILE'
export const DOCUMENT_MUTATOR_SET_NAME = 'DOCUMENT_MUTATOR_SET_NAME'
export const DOCUMENT_MUTATOR_SET_PROPERTY_ID = 'DOCUMENT_MUTATOR_SET_PROPERTY_ID'
